import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

export const containerStyle = style({
  width: rem(200),
  height: rem(200),
  alignSelf: "center",
});

export const illustrationContainerStyle = style({
  width: "100%",
  height: "100%",
});

export const indexTextStyle = style({
  fontSize: rem(170),
  lineHeight: 1,
});
